export default (state = [], action = {}) => {
    if (action.type === 'GET_NEXT_QUIZ_LIST_SUCCESS') {
        return action.payload;
    } else if (action.type === 'TOGGLE_QUIZ__SAVED_SUCCESS') {
        //change state of question from list of questions being shown on screen.
        let quizzes = state;
        let quizList = quizzes.map((quiz)=>{
            quiz = { ...quiz };// copy
            if (quiz._id !== action.payload.quizId) {
                return quiz;
            } else {
                //toggle status.
                quiz.isSaved = !quiz.isSaved;
                return quiz;
            }
        });
        quizList = [ ...quizList ];
        return quizList;
    }
    return state;
};
